import { useRef, useCallback, useEffect } from 'react'
import {
  getOrCreateSession,
  trackStep,
  completeSession,
  trackCTAClick,
} from '../data/analyticsStore'

export function useAnalytics() {
  const sessionIdRef = useRef<string | null>(null)

  // Helper to ensure we always have a session ID
  const getSessionId = useCallback(() => {
    if (!sessionIdRef.current) {
      sessionIdRef.current = getOrCreateSession()
    }
    return sessionIdRef.current
  }, [])

  // Auto-register visitor on first load
  useEffect(() => {
    getSessionId()
  }, [getSessionId])

  const startSession = useCallback(() => {
    return getSessionId()
  }, [getSessionId])

  const track = useCallback(
    (step: string, data?: Record<string, unknown>) => {
      const id = getSessionId()
      trackStep(id, step, data)
    },
    [getSessionId],
  )

  const complete = useCallback(
    (resultId: string) => {
      const id = getSessionId()
      completeSession(id, resultId)
    },
    [getSessionId],
  )

  const clickCTA = useCallback(() => {
    const id = getSessionId()
    trackCTAClick(id)
  }, [getSessionId])

  return { startSession, track, complete, clickCTA }
}
